import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Toggle } from 'cv-library-react-web';
import { themes } from 'cv-react-core';
import getTheme from './Switch.theme';

const { themeComponent } = themes;
const ThemedToggle = themeComponent(Toggle, getTheme);

const Switch = forwardRef(function Switch(props, ref) {
  const {
    showLabels = false,
    onLabel = 'On',
    offLabel = 'Off',
    labelGap = 8,
    labelFormatter, // optional: (checked:boolean) => string
    labelPosition = 'sides', // 'sides' | 'right' | 'left'
    containerStyle,
    ...rest
  } = props;

  if (!showLabels) {
    return (
        <ThemedToggle
            ref={ ref }
            { ...rest } />
    );
  }

  const offText = labelFormatter ? labelFormatter(false) : offLabel;
  const onText = labelFormatter ? labelFormatter(true) : onLabel;

  const wrapStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: labelGap,
    ...containerStyle,
  };

  if (labelPosition === 'left') {
    return (
        <span style={ wrapStyle }>
            <span className="c-switch-label c-switch-label--left">
                { offText }
            </span>
            <ThemedToggle
                ref={ ref }
                { ...rest } />
        </span>
    );
  }

  if (labelPosition === 'right') {
    return (
        <span style={ wrapStyle }>
            <ThemedToggle
                ref={ ref }
                { ...rest } />
            <span className="c-switch-label c-switch-label--right">
                { onText }
            </span>
        </span>
    );
  }

  // default: 'sides'
  return (
      <span style={ wrapStyle }>
          <span className="c-switch-label c-switch-label--off">
              { offText }
          </span>
          <ThemedToggle
              ref={ ref }
              { ...rest } />
          <span className="c-switch-label c-switch-label--on">
              { onText }
          </span>
      </span>
  );
});

Switch.displayName = 'Switch';

Switch.propTypes = {
  showLabels: PropTypes.bool,
  onLabel: PropTypes.string,
  offLabel: PropTypes.string,
  labelGap: PropTypes.number,
  labelFormatter: PropTypes.func,
  labelPosition: PropTypes.oneOf([
    'sides',
    'left',
    'right',
  ]),
  containerStyle: PropTypes.object,
};

export default Switch;
